import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import Container from "./../../ui/container";
import hero1 from "./../../assets/images/home/hero/1.webp";
import hero2 from "./../../assets/images/home/hero/2.webp";
import hero3 from "./../../assets/images/home/hero/3.webp";
import "../../css/home-hero.css";

const HomeHero = () => {
  const swiperRef = useRef(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="home-hero-root">
      <Swiper
        ref={swiperRef}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
      >
        {SLIDES.map((item) => (
          <SwiperSlide key={item.img}>
            <SliderContent
              img={item.img}
              title={item.title}
              description={item.description}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

const SLIDES = [
  {
    title: "California's Original Baghouse Experts",
    description: "The First Name in Air Pollution Control Services",
    img:hero2 ,
    pagenationItemtitle: "Tax strategy",
  },
  {
    title: "Decades of Industrial Experience",
    description: "Trusted by California’s Top Manufacturers",
    img: hero3,
    pagenationItemtitle: "Consulting Service",
  },
];

const SliderContent = ({ img, title, description }) => {
  return (
    <div className="home-hero-slide">
      <img
        src={img}
        alt="California's Original Baghouse Experts"
        className="home-hero-bg"
      />
      <div className="home-hero-overlay"></div>
      <Container>
        <div className="home-hero-content-grid">
          <div className="home-hero-content">
            <h1 className="home-hero-title">{title}</h1>
            <p className="home-hero-desc">{description}</p>
          </div>
          <div></div>
        </div>
      </Container>
    </div>
  );
};

export default HomeHero;
